import { types } from './actions';

const initialState = {
  areTermsAndConditionsFetching: false,
  termsAndConditions: null,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.FETCH_TERMS_AND_CONDITIONS_ERROR:
      return {
        ...state,
        areTermsAndConditionsFetching: false,
      };
    case types.FETCH_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        areTermsAndConditionsFetching: false,
        termsAndConditions: payload.termsAndConditions,
      };

    case types.UPDATE_TERMS_AND_CONDITIONS_ERROR:
      return {
        ...state,
        areTermsAndConditionsFetching: false,
      };
    case types.UPDATE_TERMS_AND_CONDITIONS_REQUEST:
      return {
        ...state,
        areTermsAndConditionsFetching: true,
      };
    case types.UPDATE_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        areTermsAndConditionsFetching: false,
        termsAndConditions: payload.termsAndConditions,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.settings.digitalQuote.termsAndConditions;

export const areTermsAndConditionsFetching = (state) =>
  getScope(state).areTermsAndConditionsFetching;

export const getTermsAndConditions = (state) =>
  getScope(state).termsAndConditions;
